import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';

import InputLabel from '@material-ui/core/InputLabel';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import {AUTHORIZATION_HEADER, SERVER_URL} from '../../shared/utils/Constants';
import {toast} from 'react-toastify';

import ReCAPTCHA from 'react-google-recaptcha';

import OutlinedInput from "@material-ui/core/OutlinedInput";
import PasswordResetInit from "./PasswordResetInit";
import PasswordResetFinish from "./PasswordResetFinish";
import Package from "../../../package.json";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import SystemParamsService from "../../shared/service/SystemParamsService";

global.appVersion = Package.version;


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 350,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    mainGuest: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        textTransform: 'none'
    }
});


class Login extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            reCaptchaToken: null,
            userName: null,
            password: null,
            panel: 'login',
            loginShow: true,
            showCaptcha: true

        };

        this.systemParamsService = new SystemParamsService();
    }

    componentDidMount() {

        this.systemParamsService.getSystemParams().then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    showCaptcha: response.showCaptcha,
                });
            }
            }
        );

        if (this.reCAPTCHA) {
            this.reCAPTCHA.reset();
        }

        if (GeneralUtils.getParameterByName('passwordChangeKey') !== null) {
            this.setState({
                panel: 'passwordResetFinish',
                passwordChangeKey: GeneralUtils.getParameterByName('passwordChangeKey')
            });
        }
        if (GeneralUtils.getParameterByName('activationKey') !== null) {
            this.setState({
                panel: 'passwordResetFinish',
                activationKey: GeneralUtils.getParameterByName('activationKey')
            });
        }


    }

    onChange = (reCaptchaToken) => {
        this.setState({reCaptchaToken: reCaptchaToken});
    }


    render() {
        if (this.state.panel === 'login') {
            return this.getLoginPanel();
        } else {
            return this.getPasswordResetPanel();
        }

    }

    getPasswordResetPanel = () => {
        const {classes} = this.props;
        return (
            <div className="login-background"
                 style={{backgroundImage: this.state.backgroundURL}}>
                <main className={classes.main}>
                    <CssBaseline/>
                    <Paper className={classes.paper}>
                        <img src={this.state.logo} alt="" style={{height: '90px'}}/>
                        <Typography component="h1" variant="h5">
                            {!GeneralUtils.isNullOrEmpty(this.state.activationKey) ? "User Activiation" : "Reset Password"}
                        </Typography>
                        <form className={classes.form}>
                            {this.getPasswordResetContent()}
                        </form>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={() => {
                                this.setState({panel: 'login'});
                                GeneralUtils.returnMainPage();
                            }}>
                            Back
                        </Button>
                    </Paper>
                </main>
            </div>
        );
    }

    getLoginPanel = () => {
        const {classes} = this.props;
        return (
            <div className="login-background"
                 style={{backgroundImage: this.state.backgroundURL}}>
                <main className={classes.main}>
                    <CssBaseline/>
                    <Paper className={classes.paper}>
                        <div className="layout-logo">
                            <a href='#/'>
                                <img alt="Logo" src="assets/layout/images/dispatchio.png"style={{marginTop:'40px'}}/>
                            </a>
                        </div>
                        <Typography component="h1" variant="subtitle1">
                            {'V ' + global.appVersion + ''}

                        </Typography>
                        <form className={classes.form}>
                            <FormControl margin="normal" required fullWidth variant="outlined">
                                <InputLabel htmlFor="userName">User Name</InputLabel>
                                <OutlinedInput id="userName" name="userName" autoComplete="userName"
                                               value={this.state.userName}
                                               onChange={this.__handleChange} autoFocus/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth variant="outlined">
                                <InputLabel htmlFor="password">Password</InputLabel>
                                <OutlinedInput name="password" type="password" id="password"
                                               autoComplete="current-password"
                                               value={this.state.password} onChange={this.__handleChange}/>
                            </FormControl>

                            <Button fullWidth size="small" className={classes.button}
                                    disabled={this.state.showCaptcha ? !this.state.reCaptchaToken : false}
                                    onClick={() => this.setState({panel: 'passwordResetInit'})}>
                                Forgot Password
                            </Button>

                            <span style={{alignItems: 'center'}}>
                                <ReCAPTCHA
                                    ref={(el) => {
                                        this.reCAPTCHA = el;
                                    }}
                                    hl="en"
                                    size="normal"
                                    sitekey="6LdsjTUfAAAAAH7TpbjBwaRYmvtPEV5YqJZeXdWK"
                                    onChange={this.onChange}/>
                            </span>

                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={this.state.showCaptcha ? !this.state.reCaptchaToken : false}
                                className={classes.button}
                                onClick={() => this.login()}>
                                Login
                            </Button>
                        </form>
                    </Paper>
                </main>
            </div>
        );
    }

    getPasswordResetContent = () => {
        if (this.state.panel === 'passwordResetInit') {
            return <PasswordResetInit/>;
        } else if (this.state.panel === 'passwordResetFinish') {
            return <PasswordResetFinish activationKey={this.state.activationKey}
                                        passwordChangeKey={this.state.passwordChangeKey}/>;
        }
    }

    __handleChange = (e) => {
        let state = {};
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        state[e.target.name] = value;
        this.setState(state);
    }

    login = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.userName) || GeneralUtils.isNullOrEmpty(this.state.password)) {
            return toast.warn("User name and password  cannot be empty!")
        }
        window.location.hash = "/";
        fetch(SERVER_URL + 'adminuser/security/login', {
            crossDomain: true,
            method: 'post',
            headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'},
            body: JSON.stringify({
                "userName": this.state.userName,
                "password": this.state.password.toString(),
                "reCaptchaToken": this.state.reCaptchaToken
            }),
        })
            .then(response => {
                if (response.ok) {
                    response.json().then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response)) {
                            fetch(SERVER_URL + 'adminuser/security/tokens/code/' + response, {
                                crossDomain: true,
                                method: 'post',
                                headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'}
                            })
                                .then(response => {
                                    if (response.ok) {
                                        response.json().then((response) => {
                                            localStorage.setItem("hsmUser", JSON.stringify(response.userDTO));
                                            localStorage.setItem("userType", "admin");
                                            localStorage.setItem("isAuthenticated", true);
                                            GeneralUtils.setJwtToCookie(response.accessToken, response.refreshToken, response.expireDate);

                                            this.props.loginSuccess();
                                        });

                                    } else {
                                        this.setState({userName: '', password: ''});
                                        GeneralUtils.notification(response);

                                    }
                                }).catch(error => {
                                GeneralUtils.notification(error);
                            });
                        }

                    });

                } else {
                    this.setState({userName: '', password: ''});
                    GeneralUtils.notification(response);

                }
            }).catch(error => {
            GeneralUtils.notification(error);
        });
    }


}


Login.propTypes = {
    classes: PropTypes.object.isRequired,
    loginSuccess: PropTypes.func,
};

export default withStyles(styles)(Login);
